import React, { Component } from "react";
import CountUp from "react-countup";
import Swiper from "react-id-swiper";

const data = [
  { Id: "1", Image: "Lander-1.jpg" },
  { Id: "2", Image: "Lander-2.jpg" },
  { Id: "3", Image: "Lander-3.jpg" },
  { Id: "4", Image: "Lander-4.jpg" },
  { Id: "5", Image: "Lander-5.jpg" },
  { Id: "6", Image: "Lander-6.jpg" },
];

export default class LibInfo extends Component {
  render() {
    const params = {
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
    };

    return (
      <div>
        {/* About Section */}
        <section className="ttm-row aboutus-section clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-6" style={{ margin: "auto" }}>
                <div className="section-title with-desc clearfix">
                  <div className="title-header">
                    <h2 className="title">
                      About <span>Library</span>
                    </h2>
                  </div>
                  <div className="title-desc justify">
                    <p>
                      The Central Library came into existence in the year of
                      1979 and occupies over 1500 square meters with a modest
                      number of books and other documents. Since its inception,
                      the Library has steadily increased its collection with a
                      completely automated Library management system Libsoft
                      12.0.0. It provides web-based access to the Online Public
                      Access Catalogue (OPAC) of the library. Student can borrow
                      books at any time during college hours. Multiple copies
                      ensure that resources are easily available for reference
                      in the Library. We always strive to attain excellence
                      through continual improvement in all spheres. Trained
                      Staff are always at hand to assist the user community.
                    </p>
                    <div className="paddingtop-1 ttm-btn-box pr-20 pb-20">
                      <a
                        style={{ margin: "0.5rem" }}
                        className="ttm-btn ttm-btn-size-sm rounded ttm-btn-style-border ttm-icon-btn-right ttm-bgcolor-skincolor"
                        href="https://drive.google.com/file/d/1yi6mQEyr3M1CqSI6CQuGahoK7FWLtiau/view?usp=sharing"
                        target="_blank"
                      >
                        Membership Form
                      </a>
                      <a
                        style={{ margin: "0.5rem" }}
                        className="ttm-btn ttm-btn-size-sm rounded ttm-btn-style-border ttm-icon-btn-right ttm-bgcolor-skincolor"
                        href="https://drive.google.com/drive/folders/1AEukXi0eSGvD3pvC6PgYEbGMZ1eg0IYu"
                        target="_blank"
                      >
                        New Arrivals
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 res-991-mt-40 res-991-text-center">
                <div className="position-relative res-991-mt-30">
                  <div className="ttm_single_image-wrapper">
                    <Swiper
                      getSwiper={null}
                      className="trancarousel"
                      {...params}
                    >
                      {data.map((item, i) => (
                        <div
                          key={i}
                          className="single_post widgets_small post_type5"
                        >
                          <img
                            className="img-fluid"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/home/" +
                              item.Image
                            }
                            alt="single-img-eighteen"
                          />
                        </div>
                      ))}
                    </Swiper>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="separator">
          <div className="sep-line mt-4 mb-4" />
        </div>

        {/* Vission/Time Section */}
        <div className="container section-title with-desc clearfix">
          <div className="row">
            <div className="col-md-6">
              <div className="title-header">
                <h5 className="title">VISION</h5>
              </div>
              <div className="title-desc">
                <p>
                  To incorporate the latest technology and adopt a user-friendly
                  approach towards students and faculty to enrich their
                  knowledge.
                </p>
              </div>
              <div className="title-header">
                <h5 className="title">MISSION</h5>
              </div>
              <div className="title-desc">
                <ul className="ttm-list ttm-list-style-icon">
                  <li>
                    <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                    <span className="ttm-list-li-content">
                      To provide a comprehensive collection of documents and
                      E-Resources useful for students and faculty
                    </span>
                  </li>
                  <li>
                    <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                    <span className="ttm-list-li-content">
                      To create a conducive environment for the acquisition of
                      knowledge
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-6">
              <div className="title-header">
                <h5 className="title">Library Timings</h5>
              </div>
              <table class="table">
                <thead style={{ backgroundColor: "#98002e", color: "white" }}>
                  <tr>
                    <th scope="col">Library Sections</th>
                    <th scope="col">Monday to Saturday</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>Reference Section</th>
                    <td>8.00 AM to 8.30 PM</td>
                  </tr>
                  <tr>
                    <th>Issue Section</th>
                    <td>8.00 AM to 5.00 PM</td>
                  </tr>
                  <tr>
                    <th>Periodical Section</th>
                    <td>8.00 AM to 8.30 PM</td>
                  </tr>
                  <tr>
                    <th>Digital Library</th>
                    <td>8.00 AM to 5.00 PM</td>
                  </tr>
                  <tr>
                    <th>Book Bank</th>
                    <td>8.00 AM to 5.00 PM</td>
                  </tr>
                  <tr>
                    <th>Reading Room</th>
                    <td>8.00 AM to 8.30 PM</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="col-md-12">
              <div className="container section-title with-desc clearfix">
                <div className="title-header">
                  <h5 className="title">Collections</h5>
                </div>
              </div>
              <div className="container">
                <div className="row ttm-fid-row-wrapper">
                  <div class="col-md-4 col-sm-4">
                    <div class="ttm-fid inside ttm-fid-view-lefticon style1">
                      <div class="ttm-fid-contents text-left">
                        <h4 class="ttm-fid-inner">
                          <CountUp start={0} end={92576} duration={5} />
                        </h4>
                        <h3 class="ttm-fid-title">Number of Books</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-4">
                    <div class="ttm-fid inside ttm-fid-view-lefticon style1">
                      <div class="ttm-fid-contents text-left">
                        <h4 class="ttm-fid-inner">
                          <CountUp start={0} end={7918} duration={5} />
                        </h4>
                        <h3 class="ttm-fid-title">E-Journals</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-4">
                    <div class="ttm-fid inside ttm-fid-view-lefticon style1">
                      <div class="ttm-fid-contents text-left">
                        <h4 class="ttm-fid-inner">
                          <CountUp start={0} end={51662} duration={5} />
                        </h4>
                        <h3 class="ttm-fid-title">E-Books</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-4">
                    <div class="ttm-fid inside ttm-fid-view-lefticon style1">
                      <div class="ttm-fid-contents text-left">
                        <h4 class="ttm-fid-inner">
                          <CountUp start={0} end={2501} duration={5} />
                        </h4>
                        <h3 class="ttm-fid-title">Bound Volumes</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-4">
                    <div class="ttm-fid inside ttm-fid-view-lefticon style1">
                      <div class="ttm-fid-contents text-left">
                        <h4 class="ttm-fid-inner">
                          <CountUp start={0} end={20} duration={5} />
                        </h4>
                        <h3 class="ttm-fid-title">Magazines</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-4">
                    <div class="ttm-fid inside ttm-fid-view-lefticon style1">
                      <div class="ttm-fid-contents text-left">
                        <h4 class="ttm-fid-inner">
                          <CountUp start={0} end={11} duration={5} />
                        </h4>
                        <h3 class="ttm-fid-title">News Paper</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="separator">
            <div className="sep-line mt-4 mb-4" />
          </div>
          <div className="title-header">
            <h5 className="title">HIGHLIGHTS</h5>
          </div>
          <div className="row">
            <div className="col-md-6 col-lg-6 col-sm-6">
              <ul className="ttm-list ttm-list-style-icon">
                <li>
                  <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                  <span className="ttm-list-li-content">
                    The Library established in the year 1979.
                  </span>
                </li>
                <li>
                  <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                  <span className="ttm-list-li-content">
                    Library having 1500 sq. mtrs. Area.
                  </span>
                </li>
                <li>
                  <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                  <span className="ttm-list-li-content">
                    Dedicated 35 Computer systems are made available in the
                    Digital Library.
                  </span>
                </li>
                <li>
                  <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                  <span className="ttm-list-li-content">
                    The Library is enriched with vast and useful collections of
                    books, E-books, International E-journals covering
                    Management, Engineering and Technology Subjects.
                  </span>
                </li>
                <li>
                  <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                  <span className="ttm-list-li-content">
                    The Library collections are Open Access and systematically
                    organized with DDC classification.
                  </span>
                </li>
              </ul>
            </div>
            <div className="col-md-6 col-lg-6 col-sm-6">
              <ul className="ttm-list ttm-list-style-icon">
                <li>
                  <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                  <span className="ttm-list-li-content">
                    Library under CCTV Surveillance.
                  </span>
                </li>
                <li>
                  <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                  <span className="ttm-list-li-content">
                    The Library has Remote access Facilities for E-Resources
                    through KNIMBUS Digital platform.
                  </span>
                </li>
                <li>
                  <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                  <span className="ttm-list-li-content">
                    DrillBit Plagiarism similarity check is available.
                  </span>
                </li>
                <li>
                  <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                  <span className="ttm-list-li-content">
                    The Library has Institutional Membership with reputed
                    Libraries like NAL, IISc, CMTI and IIMB.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Other Photos Bottom */}
        <div className="separator">
          <div className="sep-line mt-4 mb-4" />
        </div>
        <section className="ttm-row process-section clearfix">
          <div className="container-xl">
            <div className="section-title text-center with-desc clearfix">
              <div className="title-header">
                <h2 className="title">
                  BIT{" "}
                  <span>
                    <h6>Libraries are Organised as follows</h6>
                  </span>
                </h2>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="ttm-processbox-wrapper">
                  <div className="ttm-processbox text-center">
                    <div className="ttm-box-image">
                      <img
                        className="img-fluid"
                        alt="Library Photo"
                        title="Library Photo"
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/home/bottom-1.jpg"
                        }
                      />
                      <div className="process-num">
                        <span className="number">01</span>
                      </div>
                    </div>
                    <div className="featured-content">
                      <div className="featured-title">
                        <h5>Central Library</h5>
                      </div>
                      <div className="ttm-box-description">
                        Central Library is located at the Ground/ First Floor.
                      </div>
                    </div>
                  </div>
                  <div className="ttm-processbox text-center">
                    <div className="ttm-box-image">
                      <img
                        className="img-fluid"
                        alt="Library Photo"
                        title="Library Photo"
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/home/bottom-2.jpg"
                        }
                      />
                      <div className="process-num">
                        <span className="number">02</span>
                      </div>
                    </div>
                    <div className="featured-content">
                      <div className="featured-title">
                        <h5>MCA Library</h5>
                      </div>
                      <div className="ttm-box-description">
                        MCA Library is located on the 6th Floor.
                      </div>
                    </div>
                  </div>
                  <div className="ttm-processbox text-center">
                    <div className="ttm-box-image">
                      <img
                        className="img-fluid"
                        alt="Library Photo"
                        title="Library Photo"
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/home/bottom-3.jpg"
                        }
                      />
                      <div className="process-num">
                        <span className="number">03</span>
                      </div>
                    </div>
                    <div className="featured-content">
                      <div className="featured-title">
                        <h5>MBA Library</h5>
                      </div>
                      <div className="ttm-box-description">
                        MBA Library is located on the MBA block 1st Floor.
                      </div>
                    </div>
                  </div>
                  <div className="ttm-processbox text-center res-991-mb-0">
                    <div className="ttm-box-image">
                      <img
                        className="img-fluid"
                        alt="Library Photo"
                        title="Library Photo"
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/home/bottom-4.jpg"
                        }
                      />
                      <div className="process-num">
                        <span className="number">04</span>
                      </div>
                    </div>
                    <div className="featured-content">
                      <div className="featured-title">
                        <h5>Department Libraries </h5>
                      </div>
                      <div className="ttm-box-description">
                        Departmental Libraries are located in their respective
                        departments.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
